import AOS from 'aos';
import LazyLoad from 'vanilla-lazyload';

export default {
  init() {
    var firstloader = new Loader();
    firstloader.reset();
    firstloader.setCompleteCallback([function () {

      setTimeout(function () {
        $('html').removeClass('show-landing');
        $('html').addClass('show-anim');

        AOS.init({});
        $('.section .aos-init').attr('data-aos-duration', '0').addClass('aos-toggle').removeClass('aos-animate').removeClass('aos-init').addClass('invisible');
        $('.section .aos-toggle').attr('data-aos-duration', '0').removeClass('aos-animate').removeClass('aos-init').addClass('invisible');

        setTimeout(function () {

          if ($('body').hasClass('home') && window.innerWidth >= 1200) {
            $('.section.active .aos-toggle').removeClass('invisible').addClass('aos-init').attr('data-aos-duration', '700');
          } else {

            $('.section .aos-toggle').removeClass('invisible').addClass('aos-init').attr('data-aos-duration', '700');
          }

          AOS.refresh();
        }, 500);

      }, 1000);
    }]);
    firstloader.start();

    window.onbeforeunload = function () {
      $('html').removeClass('show-anim');
      $('html').addClass('show-landing');
    };


    new LazyLoad({
      elements_selector: '.lazy',
      load_delay: 300,
    });

    var current = $(window).scrollTop();
    $(window).scroll(function () {
      if ($('body').hasClass('menu-open')) {
        $(window).scrollTop(current);
      }
    });


    $('.slick-services').slick({
      autoplay: false,
      arrows: true,
      dots: false,
      centerMode: false,
      draggable: true,
      infinite: true,
      pauseOnHover: false,
      swipe: true,
      touchMove: true,
      vertical: false,
      speed: 1000,
      autoplaySpeed: 2000,
      useTransform: true,
      variableWidth: true,
      responsive: [
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            centerMode: true,
          },
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            centerMode: false,
            variableWidth: false,
          },
        },
      ],

    });

    setTimeout(function () {
      $('.slick-services').removeClass('hidden');
    }, 100);

    $('.slick-services').slick('slickGoTo', $('.slick-services li.active').parent().parent().data('slick-index'), true);


    // JavaScript to be fired on all pages
    $('select.select2').select2({
      minimumResultsForSearch: 'Infinity',
    });

    $(window).resize(function () {
      $('select.select2').select2({
        minimumResultsForSearch: 'Infinity',
      });
    });

    $('.btn-menu-open').on('click', function () {
      current = $(window).scrollTop();
      if ($('body').hasClass('menu-open')) {
        $('body').removeClass('menu-open');
      } else {
        $('body').addClass('menu-open');
      }
    });

    $('#filtre-category').on('change', function () {

      $('.card.aos-init').attr('data-aos-duration', '0').addClass('aos-toggle').removeClass('aos-animate').removeClass('aos-init').addClass('invisible');
      $('.card.aos-toggle').attr('data-aos-duration', '0').removeClass('aos-animate').removeClass('aos-init').addClass('invisible');

      setTimeout(function () {
        var params = new Array();
        var une = '';
        if ($('#filtre-une').hasClass('active')) {
          une = '.f-une';
          params.push('une');
        }

        $('.f-item').hide();
        if ($('#filtre-category').val() == 'all') {
          $(une + '.f-item').show();
        } else {
          $(une + '.f-' + $('#filtre-category').val()).show();
          params.push('c=' + $('#filtre-category').val());

        }

        if ($('.f-item').is(':visible')) {
          $('#msg_no_result').hide();
        } else {
          $('#msg_no_result').show();
        }

        history.replaceState({}, '', '?' + params.join('&'));
        setTimeout(function () {
          $('.card.aos-toggle').removeClass('invisible').addClass('aos-init').attr('data-aos-duration', '700');
          AOS.refresh();
        }, 1000);
      }, 100);
    });

    $('#filtre-category').trigger('change');

    $('#filtre-une').on('click', function () {

      $('.card.aos-init').attr('data-aos-duration', '0').addClass('aos-toggle').removeClass('aos-animate').removeClass('aos-init').addClass('invisible');
      $('.card.aos-toggle').attr('data-aos-duration', '0').removeClass('aos-animate').removeClass('aos-init').addClass('invisible');
      setTimeout(function () {
        var params = new Array();
        var une = '';
        if ($('#filtre-une').hasClass('active')) {
          $('#filtre-une').removeClass('active');
        } else {
          $('#filtre-une').addClass('active');
          une = '.f-une';
          params.push('une');
        }

        $('.f-item').hide();
        if ($('#filtre-category').val() == 'all') {
          $(une + '.f-item').show();
        } else {
          $(une + '.f-' + $('#filtre-category').val()).show();
          params.push('c=' + $('#filtre-category').val());
        }

        if ($('.f-item').is(':visible')) {
          $('#msg_no_result').hide();
        } else {
          $('#msg_no_result').show();
        }

        history.replaceState({}, '', '?' + params.join('&'));
        setTimeout(function () {

          $('.card.aos-toggle').removeClass('invisible').addClass('aos-init').attr('data-aos-duration', '700');
          AOS.refresh();
        }, 1000);
      }, 100);
    });

  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};

function Loader() {
  this.id = Math.random() * 1000;
  this.reset();
}

Loader.prototype.setContainer = function (domElmnt) {
  this.targetContainer = domElmnt
};

Loader.prototype.start = function () {
  var self = this;
  this.showBar();
  this.theInterval = setInterval(function () {
    self.intervalChecker()
  }, 1);
  this.setLoadList();
  this.loadingCheck()
};

Loader.prototype.reset = function () {
  this.theInterval = null;
  this.targetContainer = false;
  this.cbComplete = null;
  this.imgLoaded = 0;
  this.imgToLoad = 0;
  this.loadList = null;
  this.setLoadingBar();
};

Loader.prototype.setCompleteCallback = function (callbackComplete) {
  this.cbComplete = callbackComplete;
};

Loader.prototype.setLoadList = function () {
  var self = this;
  var searchlist;
  if (this.targetContainer) {
    searchlist = this.setContainer + 'div, ' + this.setContainer + ' img';
  } else {
    searchlist = 'div, img';
  }

  this.loadList = null;
  this.loadList = $(searchlist).filter(function () {

    if ($(this).css('background-image').indexOf('url') > -1) {
      return true;
    }
    var attr = $(this).attr('src');
    if (typeof attr !== typeof undefined && attr !== false) {
      return true;
    }
  });

  this.imgToLoad = 0;
  this.loadList.each(function () {
    self.imgToLoad++;
  })
};

Loader.prototype.loadingCheck = function () {
  var self = this;
  var tabUlr = new Array();

  this.loadList.each(function () {

    if (this.tagName.toLowerCase() != 'img') {

      var regular = new RegExp(/url\(([^()]*)\)/);
      var bi = $(this).css('background-image').match(regular).pop();
      var regReplace = new RegExp('[\'"]', 'gi');
      bi = bi.replace(regReplace, ''); // bug IE, Safari, EDGE, Chrome
      if (tabUlr.indexOf(bi) < 0) {
        tabUlr.push(bi)
      }

    } else {

      var imgsrc = $(this).attr('src');
      if (tabUlr.indexOf(imgsrc) < 0) {
        tabUlr.push(imgsrc)
      }

    }
  });

  this.imgToLoad = tabUlr.length

  for (var n = 0; n < tabUlr.length; n++) {
    $('<img/>').on('load', function () {
      $(this).remove();
      self.imgLoaded++
    }).on('error', function () {
      $(this).remove();
      self.imgLoaded++
    }).attr('src', tabUlr[n]);
  }
};

Loader.prototype.intervalChecker = function () {
  this.setLoadingBar();
  this.checkForCallback();
};

Loader.prototype.checkForCallback = function () {
  if (this.imgLoaded >= this.imgToLoad) {
    clearTimeout(this.theInterval);
    this.hideBar();
    this.theInterval = null;
    for (var i = 0; i < this.cbComplete.length; i++) {
      this.cbComplete[i]()
    }

    $(window).trigger('loadComplete');
  }
};

Loader.prototype.setLoadingBar = function () {
  var percent;
  if (this.imgToLoad > 0) {
    percent = this.imgLoaded / this.imgToLoad * 100;
  } else {
    percent = 0
  }
  // var self = this
  setTimeout(function () {
    $('#loaderbar').css('width', Math.ceil(percent) + '%');
  })
};

Loader.prototype.hideBar = function () {
  $('#loaderbar').fadeOut();
};

Loader.prototype.showBar = function () {
  $('#loaderbar').fadeIn(100);
};

Loader.prototype.autoDestroy = function () {
  for (var key in this) {
    this[key] = null;
  }
};

Loader.prototype.sleep = function (milliseconds) {
  var start = new Date().getTime();
  for (var i = 0; i < 1e7; i++) {
    if ((new Date().getTime() - start) > milliseconds) {
      break;
    }
  }
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js